import bind from "bind-decorator";
import { ERROR_MESSAGE } from "../const";
import {
  ILogHealthCheckDataReq,
  IRestServices,
  LogHealthCheckDataParams,
} from "../types";

export default class LogHealthCheckService {
  private requestTimeStart: number;

  constructor(
    private services: IRestServices,
    private parameters?: LogHealthCheckDataParams
  ) {
    this.parameters = parameters ?? {
      pageId: "60024_vk",
      event: null,
    };

    this.requestTimeStart = Date.now();
  }

  @bind
  public sendSuccess(text?: string): void {
    try {
      this.services.health.get<ILogHealthCheckDataReq>(``, {
        params: {
          _: Date.now(), // cache flush
          text,
          pageId: this.parameters.pageId,
          event: this.parameters.event,
          timing: this.delta,
          result: "0",
        },
      });
    } catch (error) {
      console.log(`${ERROR_MESSAGE} - ${(error as Error).message}`);
    }
  }

  @bind
  public sendFailure(browserError?: string, text?: string): void {
    try {
      this.services.health.get<ILogHealthCheckDataReq>(``, {
        params: {
          _: Date.now(), // cache flush
          browserError,
          text,
          pageId: this.parameters.pageId,
          event: this.parameters.event,
          timing: this.delta,
          result: "1",
        },
      });
    } catch (error) {
      console.log(`${ERROR_MESSAGE} - ${(error as Error).message}`);
    }
  }

  private get delta() {
    return Date.now() - this.requestTimeStart;
  }
}
